import React from 'react'

import Question from 'lemon-campaign-ui/lib/organisms/Question'

export default ({ component, defaults, recursive }) => {
  if (!component.components.length) {
    return null
  }

  const questionTypeMap = {
    questionMedia: 'media',
    questionText: 'text',
    questionForm: 'form',
  }

  return (
    <Question
      {...defaults}
      draft={component.content.wysiwyg}
      align={component.content.align}
      color={component.content.color || ''}
      type={questionTypeMap[component.componentType]}
    >
      {recursive(component.components)}
    </Question>
  )
}
